import NBType from '@netbase/nb-type'

/**
 * @typedef {object} AlertSubscriptionSchema
 * @property {number} subscriberId
 * @property {number} subscriptionId
 * @property {string} uuid
 */
const AlertSubscriptionSchema = NBType.object().shape('AlertSubscriptionSchema', {
  /* @prop */
  subscriberId: NBType.number(),
  /* @prop */
  subscriptionId: NBType.number(),
  /* @prop */
  uuid: NBType.string()
  /* END */
})
export default AlertSubscriptionSchema
// RESERVE BELOW
